export default "__VITE_ASSET__Dk5ag5SZ__"